import type { FlightSearchParams } from 'hooks/useSearchFlights'
import type { TransportOption } from 'tripPlanner/api/types'

interface FlatSearchParams {
  departureAirport?: string
  arrivalAirport?: string
  departureDate?: string
  returnDate?: string
  numAdults?: number
  numChildren?: number
  numInfants?: number
  fareClass?: string
  fareType?: string
}

function isFlatFormat(parsed: any): parsed is FlatSearchParams {
  return parsed && !parsed.itinerary && typeof parsed.departureAirport === 'string'
}

function normaliseSearchParams(parsed: any): FlightSearchParams | undefined {
  if (parsed.itinerary && parsed.occupancies) return parsed as FlightSearchParams

  if (!isFlatFormat(parsed)) return undefined

  const itinerary = [{
    departureAirport: parsed.departureAirport!,
    arrivalAirport: parsed.arrivalAirport!,
    departureDate: parsed.departureDate!,
  }]

  if (parsed.returnDate) {
    itinerary.push({
      departureAirport: parsed.arrivalAirport!,
      arrivalAirport: parsed.departureAirport!,
      departureDate: parsed.returnDate,
    })
  }

  return {
    itinerary,
    occupancies: [{
      adults: parsed.numAdults ?? 1,
      children: parsed.numChildren ?? 0,
      infants: parsed.numInfants ?? 0,
    }],
    fareClass: parsed.fareClass ?? 'economy',
    fareType: parsed.returnDate ? 'return' : undefined,
  }
}

function parseSearchParams(paramsJson: string | undefined): FlightSearchParams | undefined {
  if (!paramsJson) return undefined
  try {
    const parsed = JSON.parse(paramsJson)
    return normaliseSearchParams(parsed)
  } catch {
    return undefined
  }
}

function isBookedFlightOption(option: TransportOption): boolean {
  const isSavedItemDataBooked = option.savedItemData?.isBooked === true
  return ('isBooked' in option && option.isBooked === true) || isSavedItemDataBooked
}

export { parseSearchParams, isBookedFlightOption }
